import React from 'react';

import MDBox from 'components/MDBox';
import { Card } from '@mui/material';
import SiparisAgaci from 'layouts/aaro/components/Siparis';

const DetailsPage = ({ queries, orderID }) => {
    return (
        <MDBox mb={3}>
            <Card>
                <SiparisAgaci dekontID={orderID} />
            </Card>
        </MDBox>
    );
};

export default DetailsPage;
